// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3MXfj","errors":"Errors_errors__3IdgW"};